<template>
    <div class="conversion-banner">
        <div class="content">
            <div class="text">
                {{ slugInfo.categoryTitle }}
            </div>
            <div class="action">
                <eg-button variant="eg-yellow" size="large" @click="goToForm">
                    Solicitar um Orçamento
                    <span class="material-icons-outlined material icon">keyboard_double_arrow_right</span>
                </eg-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        slugInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    setup(_, { root }) {
        const goToForm = () => {
            root.$el.querySelector('#form').scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                root.$el.querySelector('#name input').focus();
            }, 500);
        };

        return { goToForm };
    },
};
</script>

<style lang="scss" scoped>
.conversion-banner {
    @apply py-8 md:py-8 lg:py-16;
    background: linear-gradient(90.93deg, #007bff 0%, #0e53a5 100%);
    .content {
        @apply container mx-auto px-8 grid grid-cols-12;
        .text {
            @apply col-span-12 lg:col-span-8 lg:pr-6 mb-3 sm:mb-5  lg:mb-0 text-center lg:text-left;
            font-size: 28px;
            color: white;
            @media screen and (max-width: 1024px) {
                font-size: 22px;
            }
        }
        .action {
            @apply col-span-12 lg:col-span-4 flex lg:justify-end justify-center items-center;
            ::v-deep .eg-button {
                @apply uppercase font-bold;
                font-size: 16px;
                @media screen and (max-width: 1024px) {
                    font-size: 13px;
                }
                @media screen and (max-width: 330px) {
                    font-size: 11px;
                }
            }
            .icon {
                top: 6px;
                @media screen and (max-width: 1024px) {
                    top: 3px;
                }
                @media screen and (max-width: 330px) {
                    top: 5px;
                    font-size: 13px !important;
                }
            }
        }
    }
}
</style>
